function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import LineString from '../LineString';
import Geometry from '../Geometry';
import hasInterface from '../../../../../hasInterface';
import Collection from '../../../../../java/util/Collection';
import LinearRing from '../LinearRing';
import GeometryComponentFilter from '../GeometryComponentFilter';
import ArrayList from '../../../../../java/util/ArrayList';
var LinearComponentExtracter = /*#__PURE__*/function () {
  function LinearComponentExtracter() {
    _classCallCheck(this, LinearComponentExtracter);
    LinearComponentExtracter.constructor_.apply(this, arguments);
  }
  return _createClass(LinearComponentExtracter, [{
    key: "filter",
    value: function filter(geom) {
      if (this._isForcedToLineString && geom instanceof LinearRing) {
        var line = geom.getFactory().createLineString(geom.getCoordinateSequence());
        this._lines.add(line);
        return null;
      }
      if (geom instanceof LineString) this._lines.add(geom);
    }
  }, {
    key: "setForceToLineString",
    value: function setForceToLineString(isForcedToLineString) {
      this._isForcedToLineString = isForcedToLineString;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return LinearComponentExtracter;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [GeometryComponentFilter];
    }
  }], [{
    key: "getGeometry",
    value: function getGeometry() {
      if (arguments.length === 1) {
        var geom = arguments[0];
        return geom.getFactory().buildGeometry(LinearComponentExtracter.getLines(geom));
      } else if (arguments.length === 2) {
        var _geom = arguments[0];
        var forceToLineString = arguments[1];
        return _geom.getFactory().buildGeometry(LinearComponentExtracter.getLines(_geom, forceToLineString));
      }
    }
  }, {
    key: "getLines",
    value: function getLines() {
      if (arguments.length === 1) {
        var geom = arguments[0];
        return LinearComponentExtracter.getLines(geom, false);
      } else if (arguments.length === 2) {
        if (hasInterface(arguments[0], Collection) && hasInterface(arguments[1], Collection)) {
          var geoms = arguments[0];
          var lines = arguments[1];
          for (var i = geoms.iterator(); i.hasNext();) {
            var g = i.next();
            LinearComponentExtracter.getLines(g, lines);
          }
          return lines;
        } else if (arguments[0] instanceof Geometry && typeof arguments[1] === 'boolean') {
          var _geom2 = arguments[0];
          var forceToLineString = arguments[1];
          var _lines = new ArrayList();
          _geom2.apply(new LinearComponentExtracter(_lines, forceToLineString));
          return _lines;
        } else if (arguments[0] instanceof Geometry && hasInterface(arguments[1], Collection)) {
          var _geom3 = arguments[0];
          var _lines2 = arguments[1];
          if (_geom3 instanceof LineString) {
            _lines2.add(_geom3);
          } else {
            _geom3.apply(new LinearComponentExtracter(_lines2));
          }
          return _lines2;
        }
      } else if (arguments.length === 3) {
        if (typeof arguments[2] === 'boolean' && hasInterface(arguments[0], Collection) && hasInterface(arguments[1], Collection)) {
          var _geoms = arguments[0];
          var _lines3 = arguments[1];
          var _forceToLineString = arguments[2];
          for (var _i = _geoms.iterator(); _i.hasNext();) {
            var _g = _i.next();
            LinearComponentExtracter.getLines(_g, _lines3, _forceToLineString);
          }
          return _lines3;
        } else if (typeof arguments[2] === 'boolean' && arguments[0] instanceof Geometry && hasInterface(arguments[1], Collection)) {
          var _geom4 = arguments[0];
          var _lines4 = arguments[1];
          var _forceToLineString2 = arguments[2];
          _geom4.apply(new LinearComponentExtracter(_lines4, _forceToLineString2));
          return _lines4;
        }
      }
    }
  }]);
}();
export { LinearComponentExtracter as default };
LinearComponentExtracter.constructor_ = function () {
  this._lines = null;
  this._isForcedToLineString = false;
  if (arguments.length === 1) {
    var lines = arguments[0];
    this._lines = lines;
  } else if (arguments.length === 2) {
    var _lines5 = arguments[0];
    var isForcedToLineString = arguments[1];
    this._lines = _lines5;
    this._isForcedToLineString = isForcedToLineString;
  }
};